// extracted by mini-css-extract-plugin
export default {"container":"LectureContentItem_container__AD3AI","header":"LectureContentItem_header__UsG37","lectureTitle":"LectureContentItem_lectureTitle__4-mYC"};